import React from 'react'
import Podsumowanie from '../../common/pages/Podsumowanie.jsx'

const S2_Podsumowanie = (props) => {
    return (
        <Podsumowanie data={{...props, wzor: 's2'}}/>
    )
}

export default S2_Podsumowanie

